(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Collection-cards"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-artify-collection-section]';

    const initialiseSection = (section) => {
      if (!section || section.dataset.artifyInitialised === 'true') return;

      const slider = section.querySelector('[data-artify-slider]');
      const previousButton = section.querySelector('.custom-artify-collections__nav--prev');
      const nextButton = section.querySelector('.custom-artify-collections__nav--next');

      if (!slider || !previousButton || !nextButton) return;

      section.dataset.artifyInitialised = 'true';

      const scrollSlider = (direction) => {
        slider.scrollBy({
          left: slider.clientWidth * direction,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };

      previousButton.addEventListener('click', () => scrollSlider(-1), { passive: true });
      nextButton.addEventListener('click', () => scrollSlider(1), { passive: true });
    };

    const observeSection = (section) => {
      if (!section || section.dataset.artifyObserved === 'true') return;
      section.dataset.artifyObserved = 'true';

      if (Shopify.designMode || !('IntersectionObserver' in window)) {
        initialiseSection(section);
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0].isIntersecting) return;
          initialiseSection(section);
          observer.disconnect();
        },
        {
          rootMargin: '300px 0px',
          threshold: 0
        }
      );

      observer.observe(section);
    };

    const initialiseAllSections = (container = document) => {
      if (container.matches?.(selector)) observeSection(container);
      container.querySelectorAll?.(selector).forEach(observeSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseAllSections(), { once: true });
    } else {
      initialiseAllSections();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialiseAllSections(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
